<template>
  <div class="container">
    <div class="row help-wrapper">
      <!-- <header-about /> -->
      <div id="corpo" class="col s12 m12 l12 mensagem-about-geral">
        <div v-html="meta_termos_text"></div>
      </div>
    </div>
  </div>
</template>
<script>
import Loading from '@/components/Loading.vue'
import HeaderAbout from "@/components/HeaderAbout.vue"

export default {
  name: 'Termos',
  components: {
    loading: Loading,
    "header-about": HeaderAbout
  },
  data (){
    return {
      meta_termos_text: ""
    }
  },
  methods: {
  },
  mounted(){
    this.meta_termos_text = this.$store.state.meta.data.termos_privacidade.termos_uso
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Termos.vue